<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <Loading :active="isLoading">
    <div class="loadingio-spinner-pulse-nq4q5u6dq7r">
      <div class="ldio-x2uulkbinbj">
        <div></div>
        <div><img src="./assets/圖示-T寶.svg" style="width: 95%;height: 95%;margin: auto;"></div>
        <div></div>
        <div><img src="./assets/圖示-T寶.svg" style="width: 95%;height: 95%;margin: auto;"></div>
      </div>
    </div>
  </Loading>
  <DrttForm/>
</template>

<script setup>
import DrttForm from './components/DrttForm.vue'
import { computed} from "vue";
import { userStore } from "./store/pinia";
import { storeToRefs } from "pinia";
const { loadingStatus} = storeToRefs(userStore());
const isLoading = computed(() => {
  return loadingStatus.value;
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #e3edf3;
  margin-top: 60px;
}
</style>
<style type="text/css">
@keyframes ldio-x2uulkbinbj-1 {
  0% {
    top: 20px;
    height: 66px;
  }
  50% {
    top: 30px;
    height: 40px;
  }
  100% {
    top: 30px;
    height: 40px;
  }
}
@keyframes ldio-x2uulkbinbj-2 {
  0% {
    top: 24.999999999999996px;
    height: 60.00000000000001px;
  }
  50% {
    top: 30px;
    height: 40px;
  }
  100% {
    top: 30px;
    height: 40px;
  }
}
@keyframes ldio-x2uulkbinbj-3 {
  0% {
    top: 26px;
    height: 54px;
  }
  50% {
    top: 30px;
    height: 40px;
  }
  100% {
    top: 30px;
    height: 40px;
  }
}
@keyframes ldio-x2uulkbinbj-4 {
  0% {
    top: 30px;
    height: 47px;
  }
  50% {
    top: 30px;
    height: 40px;
  }
  100% {
    top: 30px;
    height: 40px;
  }
}
.ldio-x2uulkbinbj div {
  position: absolute;
  width: 40px;
  border-radius: 100%;
}
.ldio-x2uulkbinbj div:nth-child(1) {
  left: 15.5px;
  background: #36b2d9;
  animation: ldio-x2uulkbinbj-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.3s;
}
.ldio-x2uulkbinbj div:nth-child(2) {
  left: 60.5px;
  background: #f2f2f2;
  animation: ldio-x2uulkbinbj-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-x2uulkbinbj div:nth-child(3) {
  left: 105.5px;
  background: #36b2d9;
  animation: ldio-x2uulkbinbj-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-x2uulkbinbj div:nth-child(4) {
  left: 150.5px;
  background: #f2f2f2;
  animation: ldio-x2uulkbinbj-4 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}

.loadingio-spinner-pulse-nq4q5u6dq7r {
  width: 160px;
  height: 80px;
  display: inline-block;
  overflow: hidden;
  /* background: #ffffff; */
}
.ldio-x2uulkbinbj {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(0.8);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-x2uulkbinbj div {
  box-sizing: content-box;
}
/* [ldio] generated by https://loading.io */
</style>
